<template>
  <div class="solution">
    <!-- 行业解决方案标题 -->
    <div v-if="industryTitle" class="industry-title-section">
      <div class="industry-title-container">
        <h1 class="industry-title">{{ industryTitle }}</h1>
      </div>
    </div>
    <!-- 页面顶部banner -->
    <solution-banner />
    <!-- 行业面临的难题 -->
    <real-estate-challenges v-if="isRealEstatePage"></real-estate-challenges>
    <automotive-challenges v-if="isAutomotivePage"></automotive-challenges>
    <healthcare-challenges v-if="isHealthcarePage"></healthcare-challenges>
    <education-challenges v-if="isEducationPage"></education-challenges>
    <home-decoration-challenges v-if="isHomeDecorationPage"></home-decoration-challenges>
    <!-- crm 企业面临 -->
    <company-face v-if="showCompanyFace"></company-face>
    <!-- 页面主体内容 -->
    <solution-panel v-if="!isCrmPage && !isMarketingCloudPage" />
    <crm-panel v-if="isCrmPage" />
    <marketing-cloud-panel v-if="isMarketingCloudPage" />
     <!-- 客户公司 -->
    <!-- <customer-recognition></customer-recognition> -->
    <!-- crm 角色支持 -->
    <role-support v-if="showCompanyFace"></role-support>
     <!-- 市场占比 -->
    <digital-marketing v-if="!isIndustryPage"></digital-marketing>
     <!-- 营销数字化升级 -->
    <marketing-upgrade v-if="isIndustryPage"></marketing-upgrade>

  </div>
</template>

<script>
import SolutionBanner from "./components/Banner.vue"
import SolutionPanel from "./components/Panel.vue";
import CrmPanel from "./components/CrmPanel.vue";
import MarketingCloudPanel from "./components/MarketingCloudPanel.vue";
// import customerRecognition from '@/components/CustomerRecognition.vue'
import digitalMarketing from '@/components/DigitalMarketing.vue'
import CompanyFace from "./components/CompanyFace.vue";
import RoleSupport from "./components/RoleSupport.vue";
import RealEstateChallenges from "./components/RealEstateChallenges.vue";
import AutomotiveChallenges from "./components/AutomotiveChallenges.vue";
import HealthcareChallenges from "./components/HealthcareChallenges.vue";
import EducationChallenges from "./components/EducationChallenges.vue";
import HomeDecorationChallenges from "./components/HomeDecorationChallenges.vue";
import MarketingUpgrade from '@/components/MarketingUpgrade.vue';
import swTracker from '@/mixins/tracker.js'
import utils from '@/utils'

export default {
  name: "SolutionView",
  mixins: [swTracker],
  components:{
    SolutionBanner,
    SolutionPanel,
    // customerRecognition,
    digitalMarketing,
    CompanyFace,
    RoleSupport,
    CrmPanel,
    MarketingCloudPanel,
    RealEstateChallenges,
    AutomotiveChallenges,
    HealthcareChallenges,
    EducationChallenges,
    HomeDecorationChallenges,
    MarketingUpgrade,
    // marketingUpgrade,
  },
  data () {
    return {
      pathUrl: '/solution',
      pathName: '',
    }
  },
  computed: {
    isCrmPage () {
      return ['/solution/crm', '/solution/crms', '/solution/omnichannel-acquisition', '/solution/lead-conversion'].includes(this.pathUrl)
    },
    isMarketingCloudPage () {
      return ['/solution/marketing-cloud'].includes(this.pathUrl)
    },
    showCompanyFace () {
      return ['/solution/crm', '/solution/crms'].includes(this.pathUrl)
    },
    isIndustryPage () {
      return this.pathUrl.startsWith('/industry/')
    },
    isRealEstatePage () {
      return this.pathUrl === '/industry/real-estate'
    },
    isAutomotivePage () {
      return this.pathUrl === '/industry/automotive'
    },
    isHealthcarePage () {
      return this.pathUrl === '/industry/healthcare'
    },
    isEducationPage () {
      return this.pathUrl === '/industry/education'
    },
    isHomeDecorationPage () {
      return this.pathUrl === '/industry/home-decoration'
    },
    industryTitle () {
      const industryTitles = {
        '/industry/real-estate': null,
        '/industry/automotive': null,
        '/industry/healthcare': null,
        '/industry/education': null,
        '/industry/home-decoration': null
      }
      return industryTitles[this.pathUrl] || null
    }
  },
  watch: {
    '$route.path' () {
      this.pathUrl = utils.changeRoutePath(this.$route.path)
      this.pathName = this.$route.name
    },
  },
  mounted () {
    this.pathUrl = utils.changeRoutePath(this.$route.path)
    this.pathName = this.$route.name
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
.solution {
  background: #f8fafe;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

// 行业标题样式
.industry-title-section {
  background: #ffffff;
  padding: 80px 0 60px;
  color: #2D2E30;
  text-align: center;
}

.industry-title-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.industry-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

// 响应式设计
@media (max-width: 768px) {
  .industry-title-section {
    padding: 60px 0 40px;
  }
  
  .industry-title {
    font-size: 32px;
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>
